module.exports = __webpack_public_path__ + "img/69_31.821b642a.png";